<div class="pt-4 pl-md-4" *ngIf="locationNotFound">
  <h2>Location Settings Not Found</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-6" *ngIf="!locationNotFound && (serverError === null)">
  <h2 class="mb-3">
    Location Settings
    <span *ngIf="loadingOrgConfig || loadingLocation" class="text-muted"> - Loading...</span>
  </h2>

  <div class="form-group">
    <div class="d-inline">
      <select class="custom-select col-xl-4 col-lg-6 col-md-8"
              id="selectLocation" name="selectLocation"
              [(ngModel)]="selectedLocationId"
              (ngModelChange)="handleSelectLocation()"
              [disabled]="isLoading()"
              [class.disabled]="isLoading()">
        <option *ngIf="locationService.getLocations() === null">Loading...</option>
        <ng-container *ngIf="locationService.getLocations() !== null">
          <option *ngFor="let location of locationService.getLocations()"
                  [ngValue]="location.id">
            {{ location.name }}
          </option>
        </ng-container>
      </select>
    </div>
  </div>

  <hr>

  <form (submit)="saveLocationSettings()">

    <div class="form-group">
      <label for="locationCapacityInput">Facility Capacity</label>
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-5">
          <input id="locationCapacityInput" type="number" name="capacity"
                 min="1" max="1000" step="1"
                 class="form-control"
                 [(ngModel)]="location.capacity"
                 (ngModelChange)="unsavedChanges = true">
        </div>
      </div>
      <small class="form-text text-muted">
        This determines the total capacity shown on the Home and Check-In pages. Customers will not be prevented from
        checking in if the capacity has been exceeded, however the "Current Capacity" counter will turn red.
      </small>
      <div class="form-text text-danger">{{ errors.capacity }}</div>
    </div>

    <div class="form-group">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-5">
          <label for="combineSameDayCheckInsSelect">Combine same-day customer check-ins?</label>
          <select id="combineSameDayCheckInsSelect" name="combine_same_day_check_ins"
                  class="custom-select"
                  [(ngModel)]="location.combine_same_day_check_ins"
                  (ngModelChange)="unsavedChanges = true">
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Yes</option>
          </select>
        </div>
      </div>
      <small class="form-text text-muted">
        If this setting is enabled, a customer who checks in multiple times in the same day will only have one check-in entry created, and will only have their entry method debited once (e.g., only one entry pass usage will be debited). We recommend this if customers often leave and re-enter the facility.
      </small>
      <div class="form-text text-danger">{{ errors.combine_same_day_check_ins }}</div>
    </div>

    <div class="form-group">
      <app-id-list-selector *ngIf="!loadProficienciesErrorMessage"
                            [idList]="location.check_in_required_proficiency_ids"
                            [(unsavedChanges)]="unsavedChanges"
                            [options]="proficiencyList"
                            [title]="'Required proficiencies for check-in'"
                            [optionsEmptyMessage]="'No proficiencies have been created for this organization.'"></app-id-list-selector>
      <label class="mb-1" *ngIf="loadProficienciesErrorMessage">Required proficiencies for check-in</label>
      <small class="form-text text-muted">
        When a customer checks in at this location on the Check-In Site without holding these proficiencies,
        <a routerLink="/check-in-sounds-config" target="_blank">the "Check-In Success with Missing Proficiency" sound</a>
        plays and a warning is shown so staff can follow up. This never prevents the customer from checking in. Leave
        every proficiency unchecked to turn the alert off for this location.
      </small>
      <div class="form-text text-danger">{{ loadProficienciesErrorMessage }}</div>
      <div class="form-text text-danger">{{ errors.check_in_required_proficiency_ids }}</div>
    </div>

    <div class="form-group indented-subsection" *ngIf="location.check_in_required_proficiency_ids.length > 0">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-8">
          <label for="checkInRequiredProficienciesMatchModeSelect">Alert unless the customer holds</label>
          <select id="checkInRequiredProficienciesMatchModeSelect" name="check_in_required_proficiencies_match_mode"
                  class="custom-select"
                  [(ngModel)]="location.check_in_required_proficiencies_match_mode"
                  (ngModelChange)="unsavedChanges = true">
            <option [ngValue]="LocationCheckInRequiredProficienciesMatchMode.any">Any one of the selected proficiencies</option>
            <option [ngValue]="LocationCheckInRequiredProficienciesMatchMode.all">All of the selected proficiencies</option>
          </select>
        </div>
      </div>
      <div class="form-text text-danger">{{ errors.check_in_required_proficiencies_match_mode }}</div>
    </div>

    <ng-container *ngIf="orgConfig && orgConfig.open_date_enabled">

      <div class="form-group">
        <label for="openDateInput">Open Date</label>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-5">
            <app-date-picker [id]="'openDateInput'"
                             [(content)]="location.open_date"
                             (contentChange)="unsavedChanges = true"></app-date-picker>
          </div>
        </div>
        <small class="form-text text-muted">
          Any memberships purchased prior to the open date will be set to begin on the open date. If a membership allows customers to choose their start date, then customers will be prevented from choosing a start date before the open date.
        </small>
        <div class="form-text text-danger">{{ errors.open_date }}</div>
      </div>

    </ng-container>

    <div class="form-group">
      <label for="allow_climber_app_home_location_selection">
        Allow this location to be selected as a Home Location in the Climber App?
      </label>
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-5">
          <select id="allow_climber_app_home_location_selection"
                  name="allow_climber_app_home_location_selection"
                  class="custom-select"
                  [(ngModel)]="location.allow_climber_app_home_location_selection"
                  (ngModelChange)="unsavedChanges = true">
            <option [ngValue]="true">Yes</option>
            <option [ngValue]="false">No</option>
          </select>
        </div>
      </div>
      <small class="form-text text-muted">
        If "No", this location will not be presented as an option when a customer chooses their home location in the Climber App.
      </small>
      <div class="form-text text-danger">{{ errors.allow_climber_app_home_location_selection }}</div>
    </div>

    <div class="form-group">
      <label for="allow_climber_app_product_selection">
        Show this location when purchasing products in the Climber App?
      </label>
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-5">
          <select id="allow_climber_app_product_selection"
                  name="allow_climber_app_product_selection"
                  class="custom-select"
                  [(ngModel)]="location.allow_climber_app_product_selection"
                  (ngModelChange)="unsavedChanges = true">
            <option [ngValue]="true">Yes</option>
            <option [ngValue]="false">No</option>
          </select>
        </div>
      </div>
      <small class="form-text text-muted">
        If "No", this location will not be shown in any product purchase workflows in the Climber App. For example, the location will not be available when viewing the scheduled events calendar in the Climber App, and it will not be shown as an option when purchasing a single-location membership.
      </small>
      <div class="form-text text-danger">{{ errors.allow_climber_app_product_selection }}</div>
    </div>

    <ng-container *ngIf="orgConfig">

      <div class="row">
        <div class="form-group col-md-10 col-lg-8 col-xl-6">
          <label *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.tax">Receipt Info</label>
          <label *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.vat">VAT Info</label>
          <label *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.gst">GST Info</label>
          <app-markdown-editor [id]="'vatInfo'"
                               [(content)]="location.vat_info"
                               (contentChange)="unsavedChanges = true"
                               [shortEditor]="true"></app-markdown-editor>
          <small class="form-text text-muted">
            <span *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.tax">
              This included at the beginning of receipts downloaded from the Staff Site and the Climber App.
            </span>
            <span *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.vat">
              This included at the beginning of VAT receipts downloaded from the Staff Site and the Climber App.
            </span>
            <span *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.gst">
              This included at the beginning of GST receipts downloaded from the Staff Site and the Climber App.
            </span>
          </small>
          <div class="form-text text-danger">{{ errors.vat_info }}</div>
        </div>
      </div>

      <div *ngIf="orgConfigService.getOrganizationConfig().has_mailchimp_integration" class="mb-3">
        <p class="mb-1">
          The following events are synced to Mailchimp automatically whenever a customer checks in at any location:
        </p>
        <div class="rounded-table-wrapper rounded-table-tight mb-0 mailchimp-auto-events-table">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Synced To</th>
                <th>When</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>checked_in</code></td>
                <td>Event</td>
                <td>Customer</td>
                <td>Whenever the customer checks in at any location</td>
              </tr>
              <tr>
                <td><code>checked_in_using_membership</code></td>
                <td>Event</td>
                <td>Customer</td>
                <td>When the customer checks in using a membership</td>
              </tr>
              <tr>
                <td><code>checked_in_using_entry_pass</code></td>
                <td>Event</td>
                <td>Customer</td>
                <td>When the customer checks in using an entry pass</td>
              </tr>
              <tr>
                <td><code>checked_in_using_guest_pass</code></td>
                <td>Event</td>
                <td>Customer</td>
                <td>When the customer checks in using a guest pass</td>
              </tr>
              <tr>
                <td><code>checked_in_using_event_booking</code></td>
                <td>Event</td>
                <td>Customer</td>
                <td>When the customer checks in using an event booking</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="form-group" *ngIf="orgConfigService.getOrganizationConfig().has_mailchimp_integration">
        <label for="mailchimpCheckInEventNameInput">Mailchimp Check-In Event Name</label>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-5">
            <input id="mailchimpCheckInEventNameInput"
                   type="text" name="mailchimp_check_in_event_name"
                   maxlength="30"
                   class="form-control"
                   [(ngModel)]="location.mailchimp_check_in_event_name"
                   (ngModelChange)="unsavedChanges = true">
          </div>
        </div>
        <small class="form-text text-muted">
          If provided, this event will be created in Mailchimp whenever a customer checks into this location. This is in addition to the generic "checked_in" event, which is always created regardless of location.
          <br>
          Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
          <br>
          To learn more, see our
          <a href="https://capitan.helpscoutdocs.com/article/200-mailchimp-events-and-tags"
             target="_blank" rel="noopener">support article on the Capitan Mailchimp integration</a>.
        </small>
        <div class="form-text text-danger">{{ errors.mailchimp_check_in_event_name }}</div>
      </div>

      <div class="form-group"
           *ngIf="location.accounting_connection_software === AccountingSoftwareType.xero">

        <div class="row" *ngIf="!loadXeroTrackingCategoryOptionsErrorMessage">
          <div class="col-md-10 col-lg-8 col-xl-6">
            <label for="xeroTrackingCategoryOption">Xero Tracking Category Option</label>
            <div class="float-right mb-1">
              <a href="#"
                 (click)="$event.preventDefault();loadXeroTrackingCategoryOptions();">
                Refresh Options
              </a>
            </div>
            <select class="custom-select"
                    id="xeroTrackingCategoryOption"
                    name="xeroTrackingCategoryOption"
                    *ngIf="!loadingXeroTrackingCategoryOptions"
                    [(ngModel)]="selectedXeroTrackingCategoryOption"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="null">
                No Tracking Category
              </option>
              <option *ngFor="let tco of xeroTrackingCategoryOptions"
                      [ngValue]="tco">
                {{ tco.category_name }}: {{ tco.option_name }}
              </option>
            </select>
            <select class="custom-select disabled" disabled
                    *ngIf="loadingLocation || loadingXeroTrackingCategoryOptions">
              <option>Loading...</option>
            </select>
          </div>
        </div>

        <ng-container *ngIf="loadXeroTrackingCategoryOptionsErrorMessage">
          <label>Xero Tracking Category Option</label>
          <div class="alert alert-danger" *ngIf="loadXeroTrackingCategoryOptionsErrorMessage">
            {{ loadXeroTrackingCategoryOptionsErrorMessage }}
          </div>
        </ng-container>

        <small class="form-text text-muted">
          The selected tracking category option will be applied to all of this location's line items when syncing revenue data to Xero.
        </small>

      </div>

    </ng-container>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>

    <!-- Place save button first so that the enter key press activates it -->
    <div class="mt-4">
      <div class="float-right">
        <button type="submit" class="btn btn-primary"
                [disabled]="isLoading()" [class.disabled]="isLoading()">
          Save
        </button>
      </div>
      <button type="button" class="btn btn-secondary"
              (click)="loadLocation()"
              [disabled]="isLoading()" [class.disabled]="isLoading()">
        Cancel
      </button>
    </div>
  </form>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingLocation">
      Loading...
    </div>
  </div>
</div>
